import { combineReducers } from 'redux';
import appProps, { initialState as initialAppProps } from './app-props/index.tsx';
import appState, { initialState as initialAppState } from './app-state/index.tsx';

export const initialState = {
	appProps: initialAppProps,
	appState: initialAppState,
} as const;

export default combineReducers({
	appProps,
	appState,
});
